import React from 'react';
import { ReactComponent as LogoSvg} from '../assets/svg/logo.svg';
import { ReactComponent as DatabaseSvg} from '../assets/svg/database.svg';
import DatabaseWin from '../components/DatabaseWin/index.jsx';
import { useRoot } from '../hooks/useRoot.jsx';

const BasicLayout = ({children}) => {
  const { showDatabaseWin, setShowDatabaseWin, setThirdDB } = useRoot();
  return <>
    <div className="w-full h-full  min-h-full bg-[#071207] flex flex-col planogram_check_spin_full">
      <div className='flex justify-between items-center px-[35px]'>
        <div className='flex-1'></div>
        <LogoSvg className="h-[70px]"></LogoSvg>
        <div className='flex-1 flex justify-end'>
          <div onClick={() => {
            setThirdDB('');
            setShowDatabaseWin(true);
          }} className='cf-effect flex items-center bg-[#00A32E26] px-[30px] py-[6px] rounded hover:bg-[#00A32E] cursor-pointer'>
            <DatabaseSvg></DatabaseSvg>
            <span className='text-white text-base font-bold leading-none ml-2'>Database</span>
          </div>
        </div>
      </div>
      <div className='flex-1 flex px-[35px] flex-col h-0'>
        {children}
      </div>
    </div>
    <DatabaseWin show={showDatabaseWin} onClose={setShowDatabaseWin}></DatabaseWin>
  </>;
};

export default BasicLayout;